// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"main_nav-11dPOaq_","user":"user-1UnS8_TN","box":"box-1khXXpCt","ad":"ad-3KYBpEnR","search":"search-1-iTt_65","logo":"logo-UAnlzJ4A"};